import { CommandType } from "~app/common/services/cqs/CommandType";
import { ArbetsorderProduktinstruktionBaseCommand } from "./ArbetsorderProduktinstruktionBaseCommand";
export class UpdateArbetsorderProduktinstruktionCommand extends ArbetsorderProduktinstruktionBaseCommand {
    medIUtbytessimulering: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateArbetsorderProduktinstruktionCommand";

    constructor(handelssortimentId: number, produktId: number, arbetsorderId: number, produktinstruktionId: number) {
        super(UpdateArbetsorderProduktinstruktionCommand.$type, CommandType.Replace);

        this.handelssortimentId = handelssortimentId;
        this.produktId = produktId;
        this.arbetsorderId = arbetsorderId;
        this.produktinstruktionId = produktinstruktionId;
    }
}
